import { createAction, props } from '@ngrx/store';

export const setPolicyId = createAction(
  '[Context] Set Policy Id',
  props<{ policyId: string }>()
);